import React, { useRef } from 'react';
import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import AuthNavbar from '../components/Navbars/AuthNavbar';
import AuthFooter from '../components/Footers/AuthFooter';

const OrderFailure = () => {
  const mainContent = useRef(null);

  return (
    <>
      <div className="main-content bg-gradient-info d-flex flex-column min-vh-100">
        <AuthNavbar />
        <div className="flex-grow-1" ref={mainContent}>
          <div className="header  py-5">
            <Container className="mt-6 mb-3">
              <Row className="justify-content-center">
                <Col md="8" className="text-center text-white mt-7">
                  <h1>🛑 Order Canceled</h1>
                  <p>You canceled the checkout. No payment was made.</p>
                  <p>If it was a mistake, feel free to try again anytime.</p>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
        <AuthFooter className="main-content mt-auto" />
      </div>
    </>
  );
};

export default OrderFailure;
